
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoshirditaxifare() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Taxi Fare',
        heading: 'Meghana Cab : Pune to Shirdi Taxi Fare',
        headingDescription: 'Meghana Cab offers affordable Pune to Shirdi Taxi Fare options, making your spiritual journey comfortable, safe, and budget-friendly. Whether you are visiting the sacred Sai Baba temple for darshan or planning a family trip, our well-maintained fleet and experienced drivers ensure a smooth ride every time. Choose from a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers, with transparent pricing and no hidden charges. With easy online booking, timely pickups, and 24/7 customer support, Meghana Cab is your trusted choice for Pune to Shirdi travel. Book now and experience a reliable and peaceful journey at the best taxi fare.',


        top: 'Top Places to Visit in Shirdi with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a significant historical landmark located in the heart of Pune. This majestic fort once served as the seat of Peshwa power and showcases stunning Maratha architecture, large wooden gates, intricate courtyards, and fortified bastions. Though much of it was destroyed in a fire, the remains reflect its grandeur, and the evening light and sound show narrating its history draws many visitors."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892 by Sultan Aga Khan III, holds a pivotal place in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other national leaders during the Quit India Movement. The palace is set amidst sprawling gardens and houses a museum with rare photos and personal belongings of Gandhi, making it a place of historical and emotional importance for visitors."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located around 30 km from Pune, Sinhagad Fort stands as a symbol of Maratha valor and history. The fort played a key role in the Battle of Sinhagad in 1670, where Tanaji Malusare fought valiantly for Shivaji Maharaj. The fort offers trekking trails, breathtaking views of the Sahyadri mountains, and traditional food stalls serving local dishes like pithla bhakri to reward visitors after the climb."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This fascinating museum is home to over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting the rich and diverse cultural heritage of India. The collection includes antique musical instruments, weapons, intricate carvings, traditional household items, and unique sculptures from various time periods. The museum provides an educational experience that connects visitors to India’s artistic and domestic past."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut shrine dedicated to Lord Shiva, the Pataleshwar Cave Temple is an archaeological gem located in central Pune. Carved out of a single basalt rock, it features finely crafted pillars, a sanctum with a Shiva Lingam, and a circular Nandi Mandapa. Its peaceful surroundings offer a meditative atmosphere for visitors looking to explore ancient architecture in a calm setting."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this world-renowned retreat founded by spiritual leader Osho offers a variety of meditation and wellness programs. Spread across lush green landscapes with zen-style architecture and tranquil energy, the resort attracts spiritual seekers from around the world. Daily meditation sessions, therapy workshops, and a serene environment make it an ideal place to rejuvenate mentally and physically."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a favorite weekend destination for families and couples seeking relaxation near nature. Built on the Mutha River, the dam offers cool breezes, scenic views of the water and surrounding hills, and small eateries serving local snacks. It is also the site of the National Defence Academy, making it an important landmark near Pune."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by the famous Korakuen Garden in Okayama, Japan, this well-manicured garden located on Sinhagad Road offers a beautiful blend of Japanese landscaping and Indian greenery. Waterfalls, streams, bridges, and floral layouts make it a peaceful place for families, morning walkers, and photographers seeking natural beauty within the city."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic monument built by Shahaji Bhosale for his son Shivaji Maharaj in the 1630s. Though the original structure was destroyed, the current reconstructed version serves as a museum that reflects Shivaji’s early life through paintings, weapons, and historical narratives. It is an essential stop for anyone interested in Maratha history and legacy."
  },
  {
    "title": "Fergusson College Road",
    "description": "A vibrant street in the Deccan area, Fergusson College Road is known for its youthful energy, thanks to the presence of several colleges nearby. It features a lively mix of cafes, fashion boutiques, bookstores, and street food joints. Whether you’re shopping for trendy clothes or enjoying a plate of momos, this road captures the essence of Pune’s modern-day culture and lifestyle."
  }
],

"services": [
    {
        "name": "Affordable Pune to Shirdi Cab Fare",
        "description": "Get the most affordable Pune to Shirdi cab fare with Meghana Cab. Our competitive pricing ensures you enjoy a smooth and budget-friendly ride without compromising comfort. Whether you're traveling solo or in a group, we offer transparent rates with no hidden charges."
    },
    {
        "name": "Pune to Shirdi Taxi Rate Chart",
        "description": "Check the detailed Pune to Shirdi taxi rate chart to plan your trip cost-effectively. Meghana Cab provides a breakdown of fares for different vehicle types, including hatchbacks, sedans, and SUVs. Make informed decisions with clear and honest pricing."
    },
    {
        "name": "AC Cab Pune to Shirdi Price",
        "description": "Travel in comfort with our AC cab service from Pune to Shirdi. Meghana Cab offers well-maintained air-conditioned vehicles at competitive prices. Enjoy a relaxed journey in a sedan or SUV with courteous drivers and clean interiors."
    },
    {
        "name": "Shirdi Round Trip Taxi Fare Pune",
        "description": "Planning a round trip from Pune to Shirdi? Meghana Cab offers cost-effective round-trip taxi fares that include return charges, tolls, and driver allowances. Get comfort, reliability, and savings in one package."
    },
    {
        "name": "One Way Cab Fare Pune to Shirdi",
        "description": "Book a one-way cab from Pune to Shirdi at the best price. Meghana Cab ensures low-cost, one-directional travel with reliable drivers and convenient pickups. Ideal for pilgrims, solo travelers, and tourists visiting Sai Baba Temple."
    },
    {
        "name": "Taxi Fare Estimate Pune to Shirdi",
        "description": "Get an instant taxi fare estimate for your Pune to Shirdi trip. Meghana Cab offers real-time fare calculations based on car type, travel time, tolls, and route. Plan your travel with complete fare transparency and no last-minute surprises."
    },
    {
        "name": "Budget Taxi Pune to Shirdi",
        "description": "Looking for a budget-friendly taxi from Pune to Shirdi? Meghana Cab offers hatchbacks and economy sedans for pocket-friendly travel without compromising on quality. Ideal for small families and short pilgrimages."
    },
    {
        "name": "Pune to Shirdi Hatchback Taxi Fare",
        "description": "Opt for a hatchback taxi for your Pune to Shirdi travel and save more. Meghana Cab offers compact, fuel-efficient vehicles perfect for solo or duo travelers looking for a comfortable and cost-effective ride."
    },
    {
        "name": "Pune to Shirdi Sedan/SUV Fare",
        "description": "Choose a spacious sedan or SUV from Meghana Cab for your Pune to Shirdi journey. Perfect for families or groups, our vehicles offer ample space and AC comfort at a fair and transparent price."
    },
    {
        "name": "Online Cab Fare Pune to Shirdi",
        "description": "Easily check and compare Pune to Shirdi cab fares online with Meghana Cab. Our online platform lets you view real-time prices, book instantly, and select your preferred vehicle—all with upfront pricing."
    },
    {
        "name": "Fare Comparison Pune to Shirdi Cabs",
        "description": "Compare cab fares for Pune to Shirdi with Meghana Cab and see why we’re the best choice. Transparent rates, no hidden fees, and excellent service make us the most cost-effective option for your travel."
    },
    {
        "name": "Best Fare Deals Pune to Shirdi",
        "description": "Get the best fare deals on Pune to Shirdi taxis with Meghana Cab. Enjoy seasonal discounts, round trip offers, and package pricing tailored to make your pilgrimage or family trip more affordable."
    },
    {
        "name": "Pune to Shirdi Taxi with Toll Charges",
        "description": "Our Pune to Shirdi taxi fare includes all toll charges for hassle-free travel. Meghana Cab ensures complete transparency by factoring tolls and driver allowances into your final fare upfront."
    },
    {
        "name": "Cab Fare Calculator Pune to Shirdi",
        "description": "Use Meghana Cab’s fare calculator to determine the exact cost of your Pune to Shirdi trip. Simply enter your pickup location, car type, and travel date to receive an instant and accurate fare estimate."
    },
    {
        "name": "Transparent Pricing Pune to Shirdi Cabs",
        "description": "We believe in complete transparency. Meghana Cab provides fixed pricing for Pune to Shirdi travel with no hidden charges. What you see is what you pay—no last-minute surprises or surge pricing."
    }
],

"tableData": [
    ["Affordable Pune to Shirdi Cab Fare", "Pune to Shirdi Taxi Rate Chart"],
    ["AC Cab Pune to Shirdi Price", "Shirdi Round Trip Taxi Fare Pune"],
    ["One Way Cab Fare Pune to Shirdi", "Taxi Fare Estimate Pune to Shirdi"],
    ["Budget Taxi Pune to Shirdi", "Pune to Shirdi Hatchback Taxi Fare"],
    ["Pune to Shirdi Sedan/SUV Fare", "Online Cab Fare Pune to Shirdi"],
    ["Fare Comparison Pune to Shirdi Cabs", "Best Fare Deals Pune to Shirdi"],
    ["Pune to Shirdi Taxi with Toll Charges", "Cab Fare Calculator Pune to Shirdi"],
    ["Transparent Pricing Pune to Shirdi Cabs", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Shirdi Taxi Fare",
        "WhyChoosedescription": "Meghana Cab offers competitive and transparent Pune to Shirdi taxi fare options with no hidden charges. Our pricing is designed to fit your budget while delivering excellent service, whether you're traveling alone, with family, or in a group."
    },
    {
        "WhyChooseheading": "Multiple Cab Options to Match Your Budget",
        "WhyChoosedescription": "Choose from a variety of vehicles including economical hatchbacks, comfortable sedans, spacious SUVs, and tempo travellers. Each option comes with clearly defined fare rates so you can pick what works best for your trip to Shirdi."
    },
    {
        "WhyChooseheading": "Clear Fare Breakup Without Hidden Costs",
        "WhyChoosedescription": "Our Pune to Shirdi taxi fare includes driver allowance, fuel, tolls, and taxes wherever applicable. We provide a clear fare breakup upfront so you can travel worry-free and plan your budget in advance."
    },
    {
        "WhyChooseheading": "Flexible One-Way and Round Trip Fare Options",
        "WhyChoosedescription": "Whether you need a one-way drop or a round-trip service to Shirdi, Meghana Cab provides flexible fare packages tailored to your travel plans and duration of stay."
    },
    {
        "WhyChooseheading": "Special Packages for Pilgrimage Trips",
        "WhyChoosedescription": "We offer dedicated Pune to Shirdi taxi packages that include round-trip travel, temple visit time, and wait time at no extra charge. Ideal for those visiting Sai Baba temple with family or groups."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Ride for Long Distance Travel",
        "WhyChoosedescription": "Our cabs are fully air-conditioned, sanitized, and equipped for long journeys. With trained drivers and spacious seating, your Pune to Shirdi trip will be both safe and relaxing."
    },
    {
        "WhyChooseheading": "24/7 Availability and Easy Booking",
        "WhyChoosedescription": "You can book your Pune to Shirdi taxi anytime—day or night—through our website, mobile app, or phone. Get instant confirmation, fare details, and real-time driver tracking for a seamless experience."
    },
    {
        "WhyChooseheading": "No Surge Pricing – Flat Fares Even on Weekends",
        "WhyChoosedescription": "With Meghana Cab, you won’t face sudden fare hikes. Our Pune to Shirdi taxi fare remains steady even during peak travel seasons, weekends, or holidays, making us a preferred choice for thousands of travelers."
    }
]









































    }

const faqData = [
    {
        question: "What is the taxi fare from Pune to Shirdi with Meghana Cab?",
        answer: "The taxi fare from Pune to Shirdi varies based on the vehicle type and trip duration. Please contact Meghana Cab at +91 9075462128 for detailed fare information."
    },
    {
        question: "How can I book a taxi from Pune to Shirdi?",
        answer: "You can book a Pune to Shirdi taxi by calling Meghana Cab or via our website for a quick and easy booking."
    },
    {
        question: "What types of vehicles are available for Pune to Shirdi trips?",
        answer: "We offer sedans, SUVs, and tempo travellers to accommodate your travel group and comfort."
    },
    {
        question: "Is Meghana Cab available for one-way and round-trip trips to Shirdi?",
        answer: "Yes, we provide both one-way and round-trip taxi services from Pune to Shirdi."
    },
    {
        question: "Are the taxi fares inclusive of toll and driver charges?",
        answer: "Our fares typically include driver charges and fuel. Toll and parking charges may be additional based on the route."
    },
    {
        question: "How long does it take to reach Shirdi from Pune by taxi?",
        answer: "The trip usually takes around 3 to 4 hours depending on traffic conditions."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for safety?",
        answer: "Yes, all our vehicles are regularly cleaned and sanitized for your safety."
    },
    {
        question: "What payment methods are accepted for Pune to Shirdi taxi bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Shirdi trips?",
        answer: "Yes, our services are available round-the-clock to accommodate your travel schedule."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Shirdi taxi services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Shirdi taxi fares and services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Shirdi taxi fare was reasonable, and the service by Meghana Cab was excellent and comfortable.”',
    },
    {
        name: 'Ms. Meena Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a pleasant trip from Pune to Shirdi with Meghana Cab. The driver was courteous and the vehicle clean.”',
    },
];




































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Taxi Fare",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-shirdi-taxi-fare.jpg",
  "description": "Check Pune to Shirdi taxi fare with Meghana Cabs for one-way and round trip rides. Transparent pricing, AC sedans, SUVs, and budget options with toll-inclusive packages available.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6034"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-shirdi-taxi-fare"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Taxi Fare | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Check Pune to Shirdi taxi fare with Meghana Cabs for one-way and round trip rides. Transparent pricing, AC sedans, SUVs, and budget options with toll-inclusive packages available." 
  />
  <meta 
    name="keywords" 
    content="Affordable Pune to Shirdi Cab Fare, Pune to Shirdi Taxi Rate Chart, AC Cab Pune to Shirdi Price, Shirdi Round Trip Taxi Fare Pune, One Way Cab Fare Pune to Shirdi, Taxi Fare Estimate Pune to Shirdi, Budget Taxi Pune to Shirdi, Pune to Shirdi Hatchback Taxi Fare, Pune to Shirdi Sedan/SUV Fare, Online Cab Fare Pune to Shirdi, Fare Comparison Pune to Shirdi Cabs, Best Fare Deals Pune to Shirdi, Pune to Shirdi Taxi with Toll Charges, Cab Fare Calculator Pune to Shirdi, Transparent Pricing Pune to Shirdi Cabs" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirditaxifare;